import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

const features = [
  'Monatliche Vor-Ort-Audits durch zertifizierten Techniker',
  'Bildgebende Live-Visualisierung jeder Leckage auf dem Display',
  'Quantifizierte Leckliste in m³/h und €/Jahr',
  'Prüfsichere Berichte als Daten­grundlage für CSRD, EnEfG & ISO 50001 (PDF · XLSX)',
  'TÜV-konforme Dokumentation für Energieaudit & Umsetzungsplan',
  'Reparatur-Priorisierung nach ROI',
  'Dokumentation der eingesparten kWh & kg CO₂ pro Leckage',
];

export default function Pricing() {
  return (
    <section id="angebot" className="py-16 sm:py-24 md:py-32 relative" data-testid="pricing-section">
      <div className="absolute inset-0 radial-glow opacity-50 pointer-events-none" />
      <div className="max-w-5xl mx-auto px-5 sm:px-6 md:px-12 relative">
        <div className="text-center mb-14">
          <div className="eyebrow justify-center inline-flex mb-5">Unser Angebot</div>
          <h2 className="font-display font-black text-slate-900 text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-[1.02]">
            Ein Abo. Messbare<br />
            <span className="text-[#0891b2]">Energieeinsparungen.</span>
          </h2>
        </div>

        <div className="card-surface p-6 sm:p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#0891b2]/10 blur-3xl pointer-events-none" />

          <div className="grid md:grid-cols-12 gap-10 relative">
            <div className="md:col-span-5">
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#0891b2] mb-3">
                Full-Service Abo
              </div>
              <div className="font-display font-black text-slate-900 text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-[1.05]">
                Kontinuierliches Monitoring.
              </div>
              <div className="text-slate-500 text-sm mt-4 font-mono-tech uppercase tracking-[0.18em]">
                Mindestlaufzeit 24 Monate
              </div>

              <a href="#kontakt" className="btn-primary mt-8" data-testid="pricing-cta">
                Audit anfragen <ArrowRight className="w-4 h-4" />
              </a>
            </div>

            <div className="md:col-span-7">
              <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-5">
                Im Abo enthalten
              </div>
              <ul className="space-y-3.5">
                {features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-slate-700">
                    <div className="mt-0.5 w-5 h-5 border border-[#0891b2]/40 grid place-items-center shrink-0">
                      <Check className="w-3 h-3 text-[#0891b2]" strokeWidth={3} />
                    </div>
                    <span className="text-[15px] leading-snug">{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
